module.exports = __webpack_public_path__ + "img/compare.2bceb6fc.svg";